import gsap from 'gsap';
import type { RefObject } from 'react';
import { fadeFromTo, fadeTo } from 'util/animation/fade/fade';

interface VideoControlsRefs {
  elementRef: RefObject<HTMLElement | null>;
}

export function seek(progress: number, progressRef: RefObject<HTMLDivElement | null>): void {
  gsap.set(progressRef.current, { width: `${progress * 100}%` });
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: VideoControlsRefs,
): void {
  timeline.add(fadeFromTo(elementRef.current as HTMLElement));
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  { elementRef }: VideoControlsRefs,
): void {
  timeline.add(fadeTo(elementRef.current as HTMLElement));
}
